module.exports = __webpack_public_path__ + "img/white-logo.a8205f63.png";